import { useEffect } from "react";
import { useDispatch } from "react-redux";
import ICONS from "../../../../assets/Icons";
import ScheduleBeneficiaryTransactionViewSchedules from "../../../../containers/Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionViewSchedules";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";

export default function ScheduleTransactionViewAllPopup({
  closeCallback,
  title,
  subtitle,
  type,
  payload,
  setShowScheduleTxnPopup,
}) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(disableSwitcher());
    return () => {
      dispatch(enableSwitcher());
    };
  }, []);
  return (
    <>
      <div onClick={(e) => e.stopPropagation()}>
        <LargePopupRedirect
          headerTitle="Beneficiary schedule details"
          headerFontWeight="semibold"
          headerFontColor="text-primary"
          headertextSize="font-md"
          headersubtext=""
          isfullViewrequired={true}
          fullviewbtnText="Open in full view"
          fullviewbtnType="button"
          fullviewisDisabled={false}
          fullviewenabledTextColor="var(--text-primary)"
          fullviewenabledBgColor="var(--primary-nav)"
          fullviewdisabledBgColor="var(--text-disabled)"
          fullviewhoverOption="white"
          fullviewicon={ICONS?.REDIRECT}
          closeiconbtnType="button"
          closeiconhandleFunction={() => {
            if (type === "scheduleAcc") {
              setShowScheduleTxnPopup(false);
              closeCallback();
            } else {
              closeCallback();
            }
          }}
          closeiconisDisabled={false}
          closeiconenabledBgColor="var(--primary-nav)"
          closeicondisabledBgColor="var(--text-disabled)"
          closeiconhoverOption="white"
          closeicon={ICONS?.CLOSE}
          isbottomSectionneed={false}
          bottomHeaderTextNeed={false}
        >
          <div className="w-full h-full overflow-y-auto overflow-x-hidden">
            <ScheduleBeneficiaryTransactionViewSchedules
              isPopup={true}
              type={type}
              payload={payload}
              closeCallback={closeCallback}
              title={title}
            />
          </div>
        </LargePopupRedirect>
      </div>
    </>
  );
}
